import FeatureImage from '../Single/FeatureImage';
import PostTitle from '../Single/PostTitle';
import PostExcerpt from '../Single/PostExcerpt';
import PostReadMore from '../Single/PostReadMore';
import PostMeta from '../Single/PostMeta';
import { classNames } from '../utils/functions';

const Default = ({ post, attributes }) => {
	const { id, thumbnail } = post;
	const { layout, subLayout, content = { height: 'auto' } } = attributes;

	const className = classNames(`apbPost`, `apbPost-${id}`, `apbPostDefault`, `${content?.height}ContentHeight`, { 'hasThumbnail': thumbnail, 'swiper-slide': 'slider' === layout });

	return <article className={className}>
		<FeatureImage post={post} attributes={attributes} />

		<div className='apbPostText'>
			<PostTitle post={post} attributes={attributes} />

			<PostMeta post={post} attributes={attributes} />

			{'title-meta' !== subLayout && <>
				<PostExcerpt post={post} attributes={attributes} />
				<PostReadMore post={post} attributes={attributes} />
			</>}
		</div>
	</article>;
};
export default Default;